function inquiryTypes(state = [], action = {}) {
    return state;
}

export default inquiryTypes;